import { StyledBadge } from './Badge.styles';
import type { BadgeProps } from './Badge.types';

export const Badge = ({ tone = 'sale', size = 'medium', children, ...props }: BadgeProps) => (
  <StyledBadge data-tone={tone} data-size={size} {...props}>
    {children}
  </StyledBadge>
);
